import React from 'react';

const CookiePage = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white shadow-lg rounded-lg p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-8">
            Çerez Politikası
          </h1>
          
          <div className="prose prose-lg max-w-none">
            <h2 className="text-xl font-semibold mb-4">1. ÇEREZ NEDİR?</h2>
            <p className="mb-4">
              Çerezler (cookies), web sitelerinin düzgün çalışabilmesi için 
              bilgisayarınıza veya mobil cihazınıza depolanan küçük metin dosyalarıdır. 
              Bu dosyalar sayesinde web sitesi size daha iyi hizmet sunabilir.
            </p>
            
            <h2 className="text-xl font-semibold mb-4">2. FİEL HOME ÇEREZ KULLANIMI</h2>
            <p className="mb-4">
              www.fielhome.com olarak, size daha iyi bir kullanıcı deneyimi 
              sunabilmek amacıyla çerezler kullanmaktayız.
            </p>
            
            <h3 className="text-lg font-semibold mb-3">2.1. Kullandığımız Çerez Türleri</h3>
            
            <h4 className="text-base font-semibold mb-2">Zorunlu Çerezler</h4>
            <p className="mb-4">
              Web sitesinin temel işlevleri için gerekli olan çerezlerdir. 
              Bu çerezler olmadan site düzgün çalışamaz.
            </p>
            <ul className="list-disc list-inside mb-4 space-y-1">
              <li>Oturum yönetimi</li>
              <li>Güvenlik kontrolü</li>
              <li>Alışveriş sepeti işlemleri</li>
              <li>Dil tercihleri</li>
            </ul>
            
            <h4 className="text-base font-semibold mb-2">Performans Çerezleri</h4>
            <p className="mb-4">
              Site performansını ölçmek ve iyileştirmek için kullanılır.
            </p>
            <ul className="list-disc list-inside mb-4 space-y-1">
              <li>Sayfa görüntüleme sayıları</li>
              <li>Ziyaret süreleri</li>
              <li>Hata raporları</li>
              <li>Site hızı analizi</li>
            </ul>
            
            <h4 className="text-base font-semibold mb-2">İşlevsellik Çerezleri</h4>
            <p className="mb-4">
              Kişiselleştirilmiş deneyim sunmak için kullanılır.
            </p>
            <ul className="list-disc list-inside mb-4 space-y-1">
              <li>Kullanıcı tercihleri</li>
              <li>Favori ürünler</li>
              <li>Görüntülenen ürünler</li>
              <li>Özelleştirilmiş içerik</li>
            </ul>
            
            <h4 className="text-base font-semibold mb-2">Pazarlama Çerezleri</h4>
            <p className="mb-4">
              Size uygun reklamlar göstermek ve pazarlama etkinliğini ölçmek için kullanılır.
            </p>
            <ul className="list-disc list-inside mb-4 space-y-1">
              <li>Hedeflı reklamlar</li>
              <li>Sosyal medya entegrasyonu</li>
              <li>E-posta pazarlama</li>
              <li>Kampanya takibi</li>
            </ul>
            
            <h2 className="text-xl font-semibold mb-4">3. ÜÇÜNCÜ TARAF ÇEREZLERİ</h2>
            <p className="mb-4">
              Sitemizde aşağıdaki üçüncü taraf servislerinin çerezleri kullanılabilir:
            </p>
            <ul className="list-disc list-inside mb-4 space-y-2">
              <li><strong>Google Analytics:</strong> Site analizi ve performans ölçümü</li>
              <li><strong>Google Ads:</strong> Reklam gösterimi ve takibi</li>
              <li><strong>Facebook Pixel:</strong> Sosyal medya reklamcılığı</li>
              <li><strong>PayTR:</strong> Ödeme işlemlerinin güvenliği</li>
              <li><strong>Hotjar:</strong> Kullanıcı deneyimi analizi</li>
            </ul>
            
            <h2 className="text-xl font-semibold mb-4">4. ÇEREZ YÖNETİMİ</h2>
            <h3 className="text-lg font-semibold mb-3">4.1. Çerez Tercihlerinizi Değiştirme</h3>
            <p className="mb-4">
              Çerez tercihlerinizi aşağıdaki yollarla yönetebilirsiniz:
            </p>
            <ul className="list-disc list-inside mb-4 space-y-2">
              <li>Tarayıcı ayarlarından çerezleri devre dışı bırakma</li>
              <li>Sitemizde bulunan çerez yönetim panelini kullanma</li>
              <li>Belirli çerez türlerini kabul etme/reddetme</li>
            </ul>
            
            <h3 className="text-lg font-semibold mb-3">4.2. Tarayıcı Ayarları</h3>
            <p className="mb-4">
              Çerezleri tarayıcı ayarlarından kontrol edebilirsiniz:
            </p>
            <ul className="list-disc list-inside mb-4 space-y-2">
              <li><strong>Chrome:</strong> Ayarlar > Gizlilik ve güvenlik > Site ayarları > Çerezler</li>
              <li><strong>Firefox:</strong> Tercihler > Gizlilik ve Güvenlik > Çerezler</li>
              <li><strong>Safari:</strong> Tercihler > Gizlilik > Çerezler</li>
              <li><strong>Edge:</strong> Ayarlar > Site izinleri > Çerezler</li>
            </ul>
            
            <h2 className="text-xl font-semibold mb-4">5. ÇEREZ VERİLERİNİN GÜVENLİĞİ</h2>
            <p className="mb-4">
              Çerez verileri güvenli bir şekilde saklanır ve işlenir. 
              Kişisel verilerinizin korunması için gerekli teknik ve idari 
              tedbirler alınmıştır.
            </p>
            
            <h2 className="text-xl font-semibold mb-4">6. ÇOCUKLARIN GİZLİLİĞİ</h2>
            <p className="mb-4">
              13 yaş altı çocuklardan bilerek kişisel veri toplanmaz. 
              Ebeveyn onayı olmadan çerez kullanımına izin verilmez.
            </p>
            
            <h2 className="text-xl font-semibold mb-4">7. İLETİŞİM</h2>
            <p className="mb-4">
              Çerez politikası ile ilgili sorularınız için:
            </p>
            <div className="bg-gray-100 p-4 rounded-lg">
              <p><strong>Adres:</strong> MAHMUDİYE MAH. ERTUĞRUL GAZİ CAD. NO: 46 A İNEGÖL/BURSA</p>
              <p><strong>Telefon:</strong> +90 552 229 90 07</p>
              <p><strong>E-posta:</strong> info@fielhome.com</p>
            </div>
            
            <h2 className="text-xl font-semibold mb-4">8. POLİTİKA DEĞİŞİKLİKLERİ</h2>
            <p className="mb-4">
              Bu çerez politikası zaman zaman güncellenebilir. 
              Önemli değişiklikler site üzerinden duyurulur.
            </p>
            
            <p className="mt-8 text-sm text-gray-600">
              Bu politika {new Date().toLocaleDateString('tr-TR')} tarihinde güncellenmiştir.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookiePage;
